/** Google OAuth Client ID（前台 GSI 登入） */
export const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  '835334567340-ncsf3npve1hgvd2l6ki1f67ueoqatc38.apps.googleusercontent.com';

export const REMEMBER_USERNAME_KEY = 'formosa_member_remember_username';
export const INVITER_CODE_KEY = 'formosa_inviter_code';

/** 從 URL 或 localStorage 取得邀請碼（Google 註冊用） */
export function getInviterCode() {
  const params = new URLSearchParams(window.location.search);
  return (
    params.get('inviter') ||
    params.get('inviterCode') ||
    localStorage.getItem(INVITER_CODE_KEY) ||
    ''
  );
}
